import { createSlice } from '@reduxjs/toolkit';
import {getCoveragesAsync} from './Actions';

export interface CoveragesValues {
  montoAsegurado?: number; 
  nombreCobertura: string;
  descripcion: string;
}

export interface CoveragesState {
  status: 'idle' | 'loading' | 'failed';
  list: Array<CoveragesValues>;
  errorMessage: string | undefined;
}

const initialState: CoveragesState = {
  status: 'idle',
  list: [],
  errorMessage: '',
};


export const coveragesSlice = createSlice({
  name: 'coverages',
  initialState,
  reducers: {
  },
  extraReducers: (builder) => {
    builder
      .addCase(getCoveragesAsync.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(getCoveragesAsync.rejected, (state, action: any) => {
        state.status = 'failed';
        state.list = [];
        state.errorMessage = action.payload.errorMessage;
      })
      .addCase(getCoveragesAsync.fulfilled, (state, action) => {
        state.status = 'idle';
        state.list = action.payload;
        state.errorMessage = ''
      })
  },
});

export default coveragesSlice.reducer;
